import User from "@/store/models/user";
import DomainTld from "@/store/models/domain/domain_tld";
import axios from "@/store/vue-axios";
import {Model} from "@/store/models/model";
import DomainHandle from "@/store/models/domain/domain_handle";
import {DomainNameserver} from "@/store/models/domain/domain_nameserver";
import {DomainNameserversDomains} from "@/store/pivot/domain_nameservers_domains";

const API_URL = process.env.API_URL
const AUTH_TOKEN = localStorage.getItem('authToken')
export class Domain extends Model {

  static entity = 'domains'
  static primaryKey = 'name'

  static fields() {
    return {
      id: this.attr(null),
      sld: this.string(''),
      tld_name: this.string(''),
      name: this.string(''),
      nameUnicode: this.string(''),

      ownerC: this.string(''),
      adminC: this.string(''),
      techC: this.string(''),
      zoneC: this.string(''),

      create: this.attr(null),
      expire: this.attr(null),
      delete: this.attr(null),
      suspended_at: this.attr(null),
      suspended_until: this.attr(null),

      authinfo: this.attr(null),
      status: this.attr(null),
      zone_id: this.attr(null),

      created_at: this.attr(null),
      updated_at: this.attr(null),

      username: this.attr(null),
      user: this.belongsTo(User, 'username'),

      // nameservers: this.hasMany(DomainNameserver, 'nameservers'),
      //@ JAN: PLEASE EXPLAIN YOUR INTENTION FOR NAMESERVERS CONFING...
      //nameservers: this.belongsToMany(DomainNameserver, DomainNameserversDomains, 'domain_id', 'domain_nameserver_id'),
      nameservers:this.attr([]),
      ns1:this.string(''),
      ns2:this.string(''),
      ns3:this.string(''),
      ns4:this.string(''),
      ns5:this.string(''),
      tld: this.belongsTo(DomainTld, 'tld_name'),
      local_change: this.boolean(false)
    }
  }

  static contacts = ['ownerC', 'adminC', 'techC', 'zoneC']
  static contact_dict = {
    ownerC : this.ownerC,
    adminC : this.adminC,
    techC : this.techC,
    zonec : this.zoneC
  }

  static async fetchall(){
    const response = await axios.get('/domain/domains' )
      .then(response=>{
        console.log('DOMAIN FETCH',response.data.domains)
        // Domain.insertOrUpdate({data:response.data.domain})
      })
      .catch(error=>error)
    return response
  }

  static modelUpdater(){
    const x = this.fetchall()
    x.then((response)=>{
      console.log('MODELUPDATER:::',response.data)
    }).catch(
      (error)=>{console.log('MODELUPDATER ERROR:::',error)}
    )
  }

  static nameservers(domainName){
    const y = {}
    const x = ['ns1','ns2','ns3','ns4','ns5'].map(el=>{y[el]=Domain.find(domainName)[el]})
    return y
  }
  static handleContacts(domainName){
    const a=[]
    const b={}
    const domain = Domain.find(domainName)
    const x = ['ownerC', 'adminC', 'techC', 'zoneC'].map(el=>{
      let item ={}
      item['key'] = el
      item['value'] = domain[el]
      a.push(item)
    })
    const y = a.map(el=>{
      b[el.key]=DomainHandle.find(el.value)['handle']
    })

    return b
  }

  static async editDomain(item){
    const response = axios.post("/domain/domains/edit",item)
    return response
  }

  static async singleFetch(name){
    const response = await axios.get('/domain/domains/show',{ params : {domainName: name} } )
      .then(res => {
        console.log('DOMAIN SINGEL:::', res.data.domain)
        Domain.insertOrUpdate({data:res.data.domain})
      })
      .catch(error=>error)
    return Domain.find(name)
  }

  static updateDomain(domainName){
    const x = this.singleFetch(domainName)
    if(Domain.find(domainName)) Domain.update({where:domainName,data:x.data.domain})
    return x.data.domain
  }

  static updateResponse(response){
    const domain = response.data.domain
    const name = domain.name
    const nameserver = domain.nameservers
    Domain.update({where:name,data:domain})
    this.namserverTransformation(nameserver,name)
    return name
  }

  static namserverTransformation(nameserver,domainName){
    console.log('NAMESERVER TRANS:::')
    const ns = {}
    const nameserverKeys = DomainNameserver.nameserverKeys
    const nss = nameserverKeys.map(el=>{
      const x = nameserver[el] ? nameserver[el].servername : false
      ns[el] = x
      if(ns[el] !== false )this.update({where:domainName , data:ns})
    })
    return ns
  }

  static async fetchO(domainName){
    const d = this.singleFetch(domainName)
    const n = this.namserverTransformation(d,domainName)
    const u = Domain.insertOrUpdate({data: {...d,...n}})
    const up = Domain.update({where:domainName,data: {...d,...n}})
    return d
  }

  static async fetch(name) {
    console.log('DOMAIN FETCH & TRANS:::')
    if (!name) return
    //if(Domain.find(name) ) return Domain.find(name)
    const response = await axios.get('/domain/domains/show', {
      params: {
        domainName: name
      }
    })
    const xxx = Domain.find(name) ?
      Domain.update({where:name,data: response.data.domain }) :
      Domain.insertOrUpdate({data: response.data.domain})
    //UPDATE NAMESERVER
    const nameserver = response.data.domain.nameservers
    const transformNs = this.namserverTransformation(nameserver, name)
    for (let i = 0; i < this.contacts.length; i++) {
      const handle = response.data.domain[this.contacts[i]]
      DomainHandle.find(handle) || await DomainHandle.fetch(handle)
    }
    return Domain.find(name)
  }

  static async getAuthinfo(name = null) {
    name = name ? name : this.name
    const response = await axios.post('domain/domains/authcode', {domainName: name})
      .then(response=>{
        Domain.insertOrUpdate({data: response.data.domain})
      })
      .catch(error=>error)
  }

  static async isAvailable(name) {
    return await axios.post('domain/domains/check', {domainName: name})
  }
  // storage.where is the identifier e.g. domainName

  static async editDomain(domainName,data){
    const x = await axios.post('/domain/domains/edit',{
      domainName:domainName,
      ...data
    })
  }

  static async save(storeData,upload=false){
    console.log('DOMAINSAVE:::', storeData)
    this.update({...storeData})
    const y = Domain.query().find(storeData.where)
    console.log('DOMAINSAVE:y:::', y)
    if(upload === true ) {
      const z = Object.keys(y)
      z.map(el=>{
        if(y[el]==='null'  || y[el] === 'option') y[el] = null
      })
      const x = await axios.post('/domain/domains/edit',{
        domainName:storeData.where,...y})
    }
    return x
  }

  static async deleteDomain(domainName, date=false){

    const x = !date ?
      await axios.delete("/domain/domains/delete", {params:{domainName:domainName}}):
      await axios.delete("/domain/domains/delete", {params:{domainName:domainName, date:date}})
    return x
  }

  static async restoreDomain(domainName){
    //const x = await axios.post("/domain/domains/restore", {params:{domainName:domainName}})
    const x = await axios.post("/domain/domains/restore", {domainName:domainName})
    return x
  }

  static async undeleteDomain(domainName){
    const x = await axios.post("/domain/domains/undelete", {domainName:domainName})
    return x
  }

  static async createDomain(x){
    const y = await axios.post('/domain/domains/create', x)
    return y
  }

  static visibleStructure(){
    return {
      info:['name'],
      dates:[
        'deleted_at',
        'created_at'
      ],
      general:[
        'authinfo'
      ],
      special:[]
    }
  }

}

export default Domain



// WEBPACK FOOTER //
// ./src/store/models/domain/domain.js